import { ROUTE_PATHS } from '@/router/constants';
import { ROLES } from './constants';
import { normalizeRole } from './normalizeRole';

export const getRoleHomePath = (user) => {
  const role = normalizeRole(user?.userRole);

  if (role === ROLES.ADMIN) {
    return ROUTE_PATHS.ADMIN_DASHBOARD;
  }

  if (role === ROLES.BRAND) {
    return ROUTE_PATHS.BRANDS;
  }

  if (role === ROLES.CREATOR && user?.userId) {
    return ROUTE_PATHS.MEDIA_KIT.replace(':id', user.userId);
  }

  return ROUTE_PATHS.REGISTRATION;
};
